import { defineComponent as _defineComponent } from 'vue';
import { onBeforeMount } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'date-option',
  props: {
    publishedOn: null
  },
  emits: ['update:published-on'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var gteValue = computed({
      get: function get() {
        var _props$publishedOn;
        return (_props$publishedOn = props.publishedOn) === null || _props$publishedOn === void 0 ? void 0 : _props$publishedOn.gte;
      },
      set: function set(newVal) {
        emit('update:published-on', {
          gte: newVal,
          lte: lteValue.value
        });
      }
    });
    var lteValue = computed({
      get: function get() {
        var _props$publishedOn2;
        return (_props$publishedOn2 = props.publishedOn) === null || _props$publishedOn2 === void 0 ? void 0 : _props$publishedOn2.lte;
      },
      set: function set(newVal) {
        emit('update:published-on', {
          gte: gteValue.value,
          lte: newVal
        });
      }
    });
    onBeforeMount(function () {
      if (!props.publishedOn) {
        emit('update:published-on', {
          gte: '',
          lte: ''
        });
      }
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      gteValue: gteValue,
      lteValue: lteValue
    };
  }
});